module.exports = __webpack_public_path__ + "img/wheel-card.85301300.svg";